document.addEventListener("DOMContentLoaded", function () {
  const wishlistButtons = document.querySelectorAll(".wishlist-btn");
  let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

  function updateWishlistUI() {
    wishlistButtons.forEach((btn) => {
      const productId = btn.getAttribute("data-product-id");
      if (wishlist.includes(productId)) {
        btn.innerHTML = `
        <svg width="24" height="24" viewBox="0 0 24 24" fill="#CC2238" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 
                   2 5.42 4.42 3 7.5 3c1.74 0 3.41 0.81 4.5 2.09
                   C13.09 3.81 14.76 3 16.5 3 
                   19.58 3 22 5.42 22 8.5
                   c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
        </svg>
      `;

      } else {
        btn.innerHTML = `
<svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.3717 18.9055L10.3712 18.905C7.89575 16.6603 5.87259 14.8228 4.4637 13.0991C3.05912 11.3807 2.30611 9.8234 2.30611 8.14583C2.30611 5.40157 4.44928 3.26705 7.1849 3.26705C8.73388 3.26705 10.227 3.99016 11.1999 5.12367L11.4974 5.47029L11.7949 5.12367C12.7677 3.99016 14.2609 3.26705 15.8099 3.26705C18.5455 3.26705 20.6887 5.40157 20.6887 8.14583C20.6887 9.8234 19.9357 11.3807 18.5311 13.0991C17.1222 14.8228 15.099 16.6603 12.6236 18.905L12.6231 18.9055L11.4974 19.9303L10.3717 18.9055Z" stroke="black" stroke-width="0.784091"/>
</svg>
`;
      }
    });
  }

  wishlistButtons.forEach((button) => {
    button.addEventListener("click", function (e) {
      e.preventDefault();
      const productId = this.getAttribute("data-product-id");

      if (wishlist.includes(productId)) {
        wishlist = wishlist.filter((id) => id !== productId);
      } else {
        wishlist.push(productId);
      }

      localStorage.setItem("wishlist", JSON.stringify(wishlist));
      updateWishlistUI();
    });
  });

  updateWishlistUI();
});
